import { render, staticRenderFns } from "./zldj.vue?vue&type=template&id=65b815f9&"
import script from "./zldj.vue?vue&type=script&lang=js&"
export * from "./zldj.vue?vue&type=script&lang=js&"
import style0 from "./zldj.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports